/* =============================================================================================
  Endpoints for different modules of the application
   ============================================================================================= */

// Dashboard Endpoints
export const DASHBOARD_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}dashboard`
export const PROFILE_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}profile`

// OPD Endpoints
export const OPD_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}opd/:id?`
export const OPD_REGISTRATION_ENDPOINT = 'registration'
export const OPD_APPOINTMENTS_ENDPOINT = 'appointments'
export const OPD_BILLING_ENDPOINT = 'billing'
export const OPD_VISITS_ENDPOINT = 'visits'
export const OPD_LAB_ORDER_ENDPOINT = 'lab-orders'
export const OPD_EMERGENCY_ENDPOINT = 'emergency/:visitId?'

// IPD Endpoints
export const IPD_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}ipd/:id?`
export const IPD_REGISTRATION_ENDPOINT = 'registration'
export const IPD_BED_ALLOCATION_ENDPOINT = 'bed-allocation'
export const IPD_DISCHARGE_ENDPOINT = 'discharge'
export const IPD_BILLING_ENDPOINT = 'billing'
export const IPD_VISITS_ENDPOINT = 'visits'
export const IPD_LAB_ORDER_ENDPOINT = 'lab-orders'

// Lab Endpoints
export const LAB_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}lab`
export const LAB_OPD_ENDPOINT = 'opd-lab-orders'
export const LAB_IPD_ENDPOINT = 'ipd-lab-orders'
export const LAB_ER_ENDPOINT = 'er-lab-orders'
export const LAB_ORDERS_PROCESSING = 'lab-order-processing'

// Lab Order Endpoints
export const LAB_ORDER_SAMPLE_COLLECTION_ENDPOINT = 'sample-collection'
export const LAB_ORDER_SAMPLE_ACKNOWLEDGEMENT_ENDPOINT =
  'sample-acknowledgement'
export const LAB_ORDER_TESTING_ENDPOINT = 'testing'
export const LAB_ORDER_VALIDATE_ENDPOINT = 'validate'
export const LAB_ORDER_DISPATCH_ENDPOINT = 'dispatch'
export const LAB_ORDER_ALL_ENDPOINT = 'all'
export const LAB_REFERRED_OUT = 'referred-out'

// Lab Management Endpoints
export const LAB_MANAGEMENT_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}lab-management`
export const LAB_MANAGEMENT_DEPARTMENTS_ENDPOINT = 'lab-departments'
export const LAB_MANAGEMENT_TESTS_ENDPOINT = 'lab-tests'
export const LAB_MANAGEMENT_PARAMETERS_ENDPOINT = 'lab-parameters'
export const LAB_MANAGEMENT_PARAMETER_RANGES_ENDPOINT = 'lab-parameter-ranges'
export const LAB_MANAGEMENT_PARAMETER_SEQUENCES_ENDPOINT =
  'lab-parameter-sequences'
export const LAB_MANAGEMENT_SAMPLE_TYPES_ENDPOINT = 'lab-sample-types'
export const LAB_MANAGEMENT_RESULT_TYPES_ENDPOINT = 'lab-result-types'
export const LAB_MANAGEMENT_METHOD_TYPES_ENDPOINT = 'lab-method-types'
export const LAB_MANAGEMENT_UNIT_TYPES_ENDPOINT = 'lab-unit-types'

// Administration Endpoint
export const ADMINISTRATION_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}administration`
export const ADMINISTRATION_PATHOLOGIST_ENDPOINT = 'pathologist'
export const ADMINISTRATION_B2B_PARTNER_ENDPOINT = 'b2b-partner'
export const ADMINISTRATION_PROCESSING_UNIT_ENDPOINT = 'processing-unit'
export const ADMINISTRATION_RBAC_ENDPOINT = 'rbac'
export const ADMINISTRATION_BED_MANAGEMENT_ENDPOINT = 'bed-management'
export const ADMINISTRATION_USER_MANAGEMENT_ENDPOINT = 'user-management'

// Patient Indent Endpoint
export const PATIENT_INDENT_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}patient-indent`
export const PATIENT_INDENT_LIST_ENDPOINT = 'list'
export const PATIENT_INDENT_RAISE_ENDPOINT = 'raise'
export const PATIENT_INDENT_RETURN_ENDPOINT = 'return'
// Settings Endpoints
export const SETTINGS_ENDPOINT = `${import.meta.env.VITE_PUBLIC_URL}settings`
export const WARDS_ENDPOINT = 'wards'
export const ROOMS_ENDPOINT = 'rooms'
export const BEDS_ENDPOINT = 'beds'

/* =============================================================================================
  Roles for Profile
   ============================================================================================= */
export const PROFILE_ROLE_PROFILE_MAIN = `${import.meta.env.VITE_APP_ROLE_PROFILE_MAIN}`

/* =============================================================================================
  Roles for Dashboard
   ============================================================================================= */
export const ADMIN_ROLE_DASHBOARD_MAIN = `${import.meta.env.VITE_APP_ROLE_DASHBOARD_MAIN}`
export const ADMIN_ROLE_DASHBOARD_PAGE = `${import.meta.env.VITE_APP_ROLE_DASHBOARD}`

/* =============================================================================================
  Roles for OPD
   ============================================================================================= */
export const OPD_ROLE_OPD_MAIN = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_MAIN}`
export const OPD_ROLE_OPD_REGISTRATION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_REGISTRATION}`
export const OPD_ROLE_OPD_APPOINTMENTS = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_APPOINTMENTS}`
export const OPD_ROLE_OPD_BILLING = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_BILLING}`
export const OPD_ROLE_OPD_LAB_ORDER = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_LAB_ORDER}`
export const OPD_ROLE_OPD_EMERGENCY = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY}`
export const OPD_ROLE_OPD_VISITS = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS}`
// roles for opd visits sub-modules
export const OPD_ROLE_OPD_VISITS_CREATE = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS_CREATE}`
export const OPD_ROLE_OPD_VISITS_LIST = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS_LIST}`
// actions for visit list section
export const OPD_VISITS_LIST_VIEW_CASE_SHEET_ACTION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS_LIST_VIEW_CASE_SHEET_ACTION}`

export const OPD_ROLE_OPD_VISITS_DETAILS = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS_DETAILS}`
export const OPD_ROLE_OPD_VISITS_CLINICAL_DETAILS = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS_CLINICAL_DETAILS}`

export const OPD_ROLE_OPD_VISITS_ACTIONS = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS_ACTIONS}`
// actions for visit actions
export const OPD_ROLE_OPD_VISITS_ACTIONS_TRANSFER_OPD_TO_IPD_ACTION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS_ACTIONS_TRANSFER_OPD_TO_IPD_ACTION}`
export const OPD_ROLE_OPD_VISITS_ACTIONS_CLOSE_VISIT_ACTION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_VISITS_ACTIONS_CLOSE_VISIT_ACTION}`

/* =============================================================================================
  Roles for Emergency
   ============================================================================================= */
export const OPD_ROLE_OPD_EMERGENCY_VISIT_DETAILS = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_VISIT_DETAILS}`
export const OPD_ROLE_OPD_EMERGENCY_CLINICAL_DETAILS = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_CLINICAL_DETAILS}`
export const OPD_ROLE_OPD_EMERGENCY_BED_ALLOCATION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_BED_ALLOCATION}`
// action for emergency bed allocation section
export const OPD_ROLE_OPD_EMERGENCY_BED_ALLOCATION_SUBMIT_ACTION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_BED_ALLOCATION_SUBMIT_ACTION}`

export const OPD_ROLE_OPD_EMERGENCY_CHILD_VISIT = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_CHILD_VISIT}`
export const OPD_ROLE_OPD_EMERGENCY_DISCHARGE_SUMMARY = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_DISCHARGE_SUMMARY}`
// action for emergency discharge summary section
export const OPD_ROLE_OPD_EMERGENCY_DISCHARGE_SUMMARY_SAVE_ACTION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_DISCHARGE_SUMMARY_SAVE_ACTION}`
export const OPD_ROLE_OPD_EMERGENCY_DISCHARGE_SUMMARY_PREVIEW_ACTION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_DISCHARGE_SUMMARY_PREVIEW_ACTION}`
export const OPD_ROLE_OPD_EMERGENCY_DISCHARGE_SUMMARY_SUBMIT_ACTION = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_DISCHARGE_SUMMARY_SUBMIT_ACTION}`

export const OPD_ROLE_OPD_EMERGENCY_BED_ALLOCATION_WRITE = `${import.meta.env.VITE_APP_OPD_ROLE_OPD_EMERGENCY_BED_ALLOCATION_WRITE}`

/* ==============================================================================================
  Roles for IPD
   ============================================================================================= */
export const IPD_ROLE_IPD_MAIN = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_MAIN}`
export const IPD_ROLE_IPD_REGISTRATION = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_REGISTRATION}`
export const IPD_ROLE_IPD_VISITS = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS}`
export const IPD_ROLE_IPD_VISITS_CREATE_AND_BED_ALLOCATION = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_CREATE_AND_BED_ALLOCATION}`
export const IPD_ROLE_IPD_VISITS_VISIT_LIST = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_VISIT_LIST}`
// actions for visit list section
export const IPD_VISITS_VISIT_LIST_VIEW_CASE_SHEET_ACTION = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_VISIT_LIST_VIEW_CASE_SHEET_ACTION}`
export const IPD_ROLE_IPD_VISITS_BED_ALLOCATION_ACTION = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_BED_ALLOCATION_ACTION}`

export const IPD_ROLE_IPD_VISITS_VISIT_DETAILS = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_VISIT_DETAILS}`
export const IPD_ROLE_IPD_VISITS_DISCHARGE_SUMMARY = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_DISCHARGE_SUMMARY}`
// action for IPD discharge summary section
export const IPD_ROLE_IPD_VISITS_DISCHARGE_SUMMARY_SAVE_ACTION = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_DISCHARGE_SUMMARY_SAVE_ACTION}`
export const IPD_ROLE_IPD_VISITS_DISCHARGE_SUMMARY_PREVIEW_ACTION = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_DISCHARGE_SUMMARY_PREVIEW_ACTION}`
export const IPD_ROLE_IPD_VISITS_DISCHARGE_SUMMARY_SUBMIT_ACTION = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_VISITS_DISCHARGE_SUMMARY_SUBMIT_ACTION}`

export const IPD_ROLE_IPD_BILLING = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_BILLING}`
export const IPD_ROLE_IPD_LAB_ORDER = `${import.meta.env.VITE_APP_IPD_ROLE_IPD_LAB_ORDER}`

/* =============================================================================================
  Lab Management Roles
  =============================================================================================*/
export const LAB_MANAGEMENT_ADMIN_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_ADMIN_ROLE}`
export const LAB_MANAGEMENT_LAB_DEPARTMENT_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_LAB_DEPARTMENT_ROLE}`
export const LAB_MANAGEMENT_LAB_TESTS_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_LAB_TESTS_ROLE}`
export const LAB_MANAGEMENT_PARAMETERS_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_PARAMETERS_ROLE}`
export const LAB_MANAGEMENT_PARAMETER_RANGES_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_PARAMETER_RANGES_ROLE}`
export const LAB_MANAGEMENT_PARAMETERS_SEQUENCES_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_PARAMETERS_SEQUENCES_ROLE}`
export const LAB_MANAGEMENT_RESULT_TYPES_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_RESULT_TYPES_ROLE}`
export const LAB_MANAGEMENT_SAMPLE_TYPES_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_SAMPLE_TYPES_ROLE}`
export const LAB_MANAGEMENT_UNIT_TYPES_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_UNIT_TYPES_ROLE}`
export const LAB_MANAGEMENT_METHOD_TYPES_ROLE = `${import.meta.env.VITE_APP_LAB_MANAGEMENT_METHOD_TYPES_ROLE}`

/* =============================================================================================
  Roles for Lab Orders
   ============================================================================================= */
export const LAB_ROLE_LAB_ORDERS_MAIN = `${import.meta.env.VITE_APP_LAB_ORDERS_MAIN}`
export const LAB_ROLE_LAB_ORDER_PROCESSING_PAGE = `${import.meta.env.VITE_APP_LAB_ORDER_PROCESSING_PAGE}`
export const LAB_ROLE_LAB_ORDERS_REFFERED_OUT_PAGE = `${import.meta.env.VITE_APP_LAB_ORDERS_REFFERED_OUT_PAGE}`

/* =============================================================================================
  Roles for Administration
    ============================================================================================= */
export const ADMIN_ROLE_ADMINISTRATION = `${import.meta.env.VITE_APP_ADMIN_ROLE_ADMINISTRATION_MAIN}`
export const ADMIN_ROLE_PATHOLOGIST = `${import.meta.env.VITE_APP_ADMIN_ROLE_PATHOLOGIST}`
export const ADMIN_ROLE_BED_MANAGEMENT = `${import.meta.env.VITE_APP_ADMIN_ROLE_BED_MANAGEMENT}`
export const ADMIN_ROLE_ROLE_MANAGEMENT = `${import.meta.env.VITE_APP_ADMIN_ROLE_ROLE_MANAGEMENT}`
export const ADMIN_ROLE_USER_MANAGEMENT = `${import.meta.env.VITE_APP_ADMIN_ROLE_USER_MANAGEMENT}`

/* =============================================================================================
  Roles for PatientIndent
    ============================================================================================= */
export const INDENT_ROLE_PATIENT_INDENT = `${import.meta.env.VITE_APP_INDENT_ROLE_PATIENT_INDENT_MAIN}`
export const INDENT_ROLE_PATIENT_INDENT_LIST = `${import.meta.env.VITE_APP_INDENT_ROLE_PATIENT_INDENT_LIST}`
export const INDENT_ROLE_PATIENT_INDENT_RAISE = `${import.meta.env.VITE_APP_INDENT_ROLE_PATIENT_INDENT_RAISE}`
export const INDENT_ROLE_PATIENT_INDENT_RETURN = `${import.meta.env.VITE_APP_INDENT_ROLE_PATIENT_INDENT_RETURN}`

// Roles for Settings
// =============================================================================================
export const SETTINGS_ROLE_BED_MANAGEMENT = `${import.meta.env.VITE_APP_SETTINGS_BED_MANAGEMENT_MENU}`
export const SETTINGS_ROLE_WARDS = `${import.meta.env.VITE_APP_SETTINGS_BED_MANAGEMENT_WARDS}`
export const SETTINGS_ROLE_ROOMS = `${import.meta.env.VITE_APP_SETTINGS_BED_MANAGEMENT_ROOMS}`
export const SETTINGS_ROLE_BEDS = `${import.meta.env.VITE_APP_SETTINGS_BED_MANAGEMENT_BEDS}`
